import axios from "axios";
import { baseUrl } from "../util";

// Flow 35 - Losses
export const getAllLosses35LCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/losses-35-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching losses 35:", error);
      setObjects([]);
    });
};

export const addLosses35LCA = ({
  productId,
  own_name,
  material,
  amount,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/losses-35-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      own_name: own_name || null,
      material: material,
      amount: amount || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding losses 35:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add loss",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateLosses35LCA = ({
  productId,
  rowId,
  own_name,
  material,
  amount,
  objects,
  setObjects,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/losses-35-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      own_name: own_name || null,
      material: material,
      amount: amount || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating losses 35:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update loss",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteLosses35LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/losses-35-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting losses 35:", error);
    });
};

// Flow 35: Get Total Impact for Losses
export const getLosses35Totals = ({
  productId,
  setTotals = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/losses-35-totals`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotals(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching losses 35 totals:", error);
      setTotals(null);
    });
};
